import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/')({
  loader: () => {
    throw redirect({
      to: '/',
    })
  },
})
